import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { roundHelper } from 'lib/helpers/round.helper.class.js';
import { unitConversionHelper } from 'lib/helpers/unit-conversion-helper.class.js';
import { match, P } from 'ts-pattern';
import { FormFieldComponent } from '../form-field.component.js';

@Component({
	selector: 'ui-weight-form-field',
	templateUrl: './weight-form-field.component.html',
	styleUrls: ['../form-fields.shared.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class WeightFormFieldComponent extends FormFieldComponent<number> {
	public readonly unit = input.required<UserDb.MeasurementUnitType>();

	public readonly weightSubtitle = computed<string>(() => {
		const unit = this.unit();
		if (unit === 'metric') {
			return 'kg';
		}
		return 'lbs';
	});

	public readonly shownWeightValue = computed<number | undefined>(() => {
		const currentUnit = this.unit();

		const shownValue = match({ value: this.currentValue(), currentUnit })
			.with({ value: P.nullish }, () => undefined)
			.with({ currentUnit: 'metric', value: P.number }, (data) => data.value)
			.with({ currentUnit: 'imperial', value: P.number }, (data) =>
				unitConversionHelper.convertKgToLbs(data.value)
			)
			.otherwise(() => undefined);

		if (!shownValue) {
			return undefined;
		}

		return roundHelper.roundTo(shownValue, 2);
	});

	constructor() {
		super();
	}

	handleModelChange(value?: number): void {
		if (!value) {
			super.updateValue(undefined);
		} else {
			if (this.unit() === 'metric') {
				// no need to convert
				super.updateValue(value);
			} else if (this.unit() === 'imperial') {
				const valueInKg = unitConversionHelper.convertLbsToKg(value);
				super.updateValue(valueInKg);
			}
		}
	}

	protected getHint(value?: number): string | undefined {
		return undefined;
	}

	protected isValueValid(value?: number): boolean {
		return true;
	}
}
